import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Hello! 我是立群，目前正在等待出國留學，在本次年會中我是 DDD 經典 15 年(Domain-Driven Design: The First 15 Years) 中文版的翻譯與審稿人，演講主要協助初學者與公司了解如何在這本書中快速定位出如何具體實行 DDD 流程以及要怎麼閱讀這本書。`}</p>
    <p>{`我是個熱愛數學與相關研究的人，並希望能夠將理論研究推向實際應用和業務。過去的經驗包含癌症免疫治療、數學優化、會計審計等，並曾與 Yahoo 合作電子商務推薦系統的開發。此外，我正從事與 Covid-19 相關的研究。我對各種知識感到好奇，並喜歡學習和分享他們，如果您有任何有趣的點子或好玩的知識，請不要猶豫與我分享您的看法!!`}</p>
    <p>{`在業餘時間，我對與 NBA 和 MLB 相關的各種運動分析充滿熱情。我也熱衷於健身、寫作、打羽毛球和唱歌。`}</p>
    <p>{`Linkedin: `}<a parentName="p" {...{
        "href": "https://www.linkedin.com/in/li-chun-su-9563a7145/"
      }}>{`https://www.linkedin.com/in/li-chun-su-9563a7145/`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      